var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"data-table table mb-0 tbl-server-info",attrs:{"id":"datatable"}},[_c('thead',{staticClass:"bg-white text-uppercase"},[_vm._t("header")],2),_c('tbody',{staticClass:"ligth-body"},[_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }